export function Video({ googleCloudKey, divClassName }: { googleCloudKey: string; divClassName: string }) {
  return (
    <div className={divClassName}>
      <video autoPlay loop muted playsInline width="100%">
        <source
          src={`https://storage.googleapis.com/prod_select_images/${googleCloudKey}.webm`}
          type="video/webm"
        />
        <source
          src={`https://storage.googleapis.com/prod_select_images/${googleCloudKey}.mp4`}
          type="video/mp4"
        />
      </video>
    </div>
  )
}
